import { Form, Select, Button } from "antd";
import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import IconSelect from "@/components/Common/IconSelect";
import { tabSchema } from "@/utils/colorSchemas";
import ReactQuill, { Quill } from "react-quill-new";
import { webFonts } from "@/utils/fonts";
import PropTypes from "prop-types";
import { v4 as uuid } from "uuid";

const Font = Quill.import("formats/font");
Font.whitelist = webFonts;
Quill.register(Font, true);

const Size = Quill.import("formats/size");
Size.whitelist = [
  "10px",
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
  "26px",
  "28px",
  "30px",
  "31px",
  "32px",
];
ReactQuill.Quill.register(Size, true);

const tabTitleModules = {
  toolbar: [[{ font: Font.whitelist }], [{ size: Size.whitelist }], [{ color: [] }], ["clean"]],
  clipboard: {
    matchVisual: false,
  },
};

const onFinishFailed = (values) => {
  // eslint-disable-next-line no-console
  console.log({ values });
};

function TabModal({
  showTabModal,
  setShowTabModal,
  tabData,
  setTabData,
  editTabData,
  setEditTabData = () => {},
  setLayouts,
  setGridData,
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (editTabData) {
      form.setFieldsValue(editTabData);
    }
  }, [editTabData]);

  const onFinish = (values) => {
    if (editTabData) {
      const data = tabData.map((i) => {
        if (i.tabId === editTabData.tabId) {
          i = { ...i, ...values };
        }
        return i;
      });
      setTabData(data);
    } else {
      setTabData((pre) => [
        ...pre.map((i) => ({ ...i, isSelected: false })),
        { ...values, isSelected: true, tabId: uuid() },
      ]);
      setLayouts({});
      setGridData([]);
    }
    form.resetFields();
    setShowTabModal(false);
    setEditTabData(null);
  };

  const handleHide = () => {
    setShowTabModal(false);
    setEditTabData(null);
    form.resetFields();
  };

  return (
    <div>
      <Modal show={showTabModal} onHide={handleHide} centered enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title className="fs-6">{editTabData ? "Edit Tab" : "Add New Tab"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            name="tabForm"
            layout="vertical"
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError={true}
          >
            <Form.Item
              label="Tab Name"
              name="name"
              rules={[{ required: true, message: "Input Tab Name" }]}
              getValueFromEvent={(content) => {
                return content;
              }}
            >
              <ReactQuill modules={tabTitleModules} theme="snow" placeholder="Input Tab Name" maxLength={4} />
            </Form.Item>

            <Form.Item
              label="Tab Icon"
              name="icon"
              rules={[
                {
                  required: true,
                  message: "Please Select a Tab Icon",
                },
              ]}
            >
              <IconSelect placeholder="Select Icon" columns={4} size="large" />
            </Form.Item>
            <Form.Item
              label="Color Schema"
              name="colorSchemeName"
              rules={[
                {
                  required: true,
                  message: "Please Select a Color Schema",
                },
              ]}
            >
              <Select
                style={{ width: "100%" }}
                size="large"
                placeholder="Select Color Schema"
                options={tabSchema?.map(({ label, value, colors }, ind) => ({
                  label: (
                    <span key={ind} className="d-flex align-items-center">
                      {colors?.length
                        ? colors?.map((color, ind) => (
                            <span key={ind} className="colorPalateBox" style={{ background: color }}></span>
                          ))
                        : ""}
                      <span className="d-inline-block ms-3"> {label} </span>
                    </span>
                  ),
                  value,
                }))}
                required
              />
            </Form.Item>

            <div className="d-flex gap-2 align-items-center justify-content-end">
              <Button type="primary" htmlType="submit">
                {editTabData ? "Save" : "Create"} Tab
              </Button>
              <Button type="primary" className="bg-secondary" onClick={handleHide} htmlType="button">
                Cancel
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default TabModal;

TabModal.propTypes = {
  showTabModal: PropTypes.bool,
  setShowTabModal: PropTypes.func,
  tabData: PropTypes.array,
  setTabData: PropTypes.func,
  editTabData: PropTypes.object,
  setEditTabData: PropTypes.func,
  setLayouts: PropTypes.func,
  setGridData: PropTypes.func,
};
